import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "m-4" }
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = { class: "col-sm-12 col-md-6 offset-md-3" }
const _hoisted_4 = { class: "ms-3 me-3 mb-0 text-center text-capitalize-first" }
const _hoisted_5 = { class: "col-sm-12 col-md-6 offset-md-3" }
const _hoisted_6 = { class: "card card-body" }
const _hoisted_7 = { class: "invoice-input-group mb-0" }
const _hoisted_8 = { class: "input-group" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-sm-12 col-md-6 offset-md-3" }
const _hoisted_12 = { class: "ms-3 me-3 mb-0 text-center text-capitalize-first" }
const _hoisted_13 = { class: "col-sm-12 col-md-6 offset-md-3" }
const _hoisted_14 = { class: "card card-body" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_17 = { class: "col-sm-8" }
const _hoisted_18 = {
  key: 0,
  class: "text-success"
}
const _hoisted_19 = {
  key: 1,
  class: "text-warning"
}
const _hoisted_20 = { class: "d-flex justify-content-center" }
const _hoisted_21 = { class: "d-flex justify-content-center mb-3" }
const _hoisted_22 = { class: "input-group input-group-sm" }
const _hoisted_23 = ["value"]
const _hoisted_24 = {
  key: 0,
  class: "d-flex justify-content-center flex-column mt-2"
}
const _hoisted_25 = { class: "input-group" }
const _hoisted_26 = ["placeholder"]
const _hoisted_27 = {
  key: 1,
  class: "row"
}
const _hoisted_28 = { class: "col-sm-12 col-md-6 offset-md-3" }
const _hoisted_29 = { class: "ms-3 me-3 mb-0 text-center text-capitalize-first" }
const _hoisted_30 = { class: "col-sm-12 col-md-6 offset-md-3" }
const _hoisted_31 = { class: "card card-body" }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_34 = { class: "col-sm-8" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = {
  key: 1,
  class: "text-warning"
}
const _hoisted_37 = {
  key: 2,
  class: "text-primary"
}
const _hoisted_38 = ["href"]
const _hoisted_39 = {
  ref: "tgBotNotificationsLink",
  href: "",
  target: "_blank",
  style: {"display":"none"}
}
const _hoisted_40 = {
  key: 0,
  class: "row"
}
const _hoisted_41 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_42 = {
  key: 1,
  class: "row"
}
const _hoisted_43 = { class: "offset-sm-4 col-sm-8" }
const _hoisted_44 = { class: "form-check small mb-0" }
const _hoisted_45 = ["value", "id", "disabled"]
const _hoisted_46 = ["for"]
const _hoisted_47 = {
  key: 0,
  class: "text-muted small"
}
const _hoisted_48 = { class: "offset-sm-4 col-sm-8" }
const _hoisted_49 = { class: "row" }
const _hoisted_50 = { class: "col-sm-12 col-md-6 offset-md-3" }
const _hoisted_51 = { class: "ms-3 me-3 mb-0 text-center" }
const _hoisted_52 = { class: "col-sm-12 col-md-6 offset-md-3" }
const _hoisted_53 = { class: "card" }
const _hoisted_54 = { class: "card-body" }
const _hoisted_55 = { class: "mb-3 row" }
const _hoisted_56 = {
  for: "timezone",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_57 = { class: "col-sm-4" }
const _hoisted_58 = {
  name: "timezone-select",
  autocomplete: "off"
}
const _hoisted_59 = { class: "mb-3 row" }
const _hoisted_60 = {
  for: "lang",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_61 = { class: "col-sm-4" }
const _hoisted_62 = {
  name: "lang-select",
  autocomplete: "off"
}
const _hoisted_63 = { class: "mb-1 row" }
const _hoisted_64 = {
  for: "inputPassword",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_65 = { class: "col-sm-4" }
const _hoisted_66 = {
  name: "change-pwd-new",
  autocomplete: "off"
}
const _hoisted_67 = { class: "mb-3 row" }
const _hoisted_68 = {
  for: "inputPasswordConf",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_69 = { class: "col-sm-4" }
const _hoisted_70 = {
  name: "change-pwd-new-repeat",
  autocomplete: "off"
}
const _hoisted_71 = { class: "mb-1 row" }
const _hoisted_72 = { class: "col-sm-8 text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_vue_qrcode = _resolveComponent("vue-qrcode")!
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isMerchant)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.helper.trans("labels.secret_key")), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("input", {
                    type: "text",
                    class: "form-control invoice-input font-monospace",
                    value: _ctx.user?.secret,
                    readonly: ""
                  }, null, 8, _hoisted_9),
                  _createVNode(_component_copy_button, {
                    class: "btn btn-copy",
                    value: _ctx.user?.secret
                  }, null, 8, ["value"])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("h5", _hoisted_12, _toDisplayString(_ctx.helper.trans("labels.2fa")), 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_LoaderWrapper, { ref: "twoFactorAuthLoader" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.helper.trans("labels.status")) + ":", 1),
                _createElementVNode("div", _hoisted_17, [
                  (_ctx.user?.is2faEnabled)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.helper.trans('labels.enabled')), 1))
                    : _createCommentVNode("", true),
                  (!_ctx.user?.is2faEnabled)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                        _cache[15] || (_cache[15] = _createElementVNode("i", { class: "fa fa-warning" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('labels.disabled')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.user?.is2faEnabled)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        type: "button",
                        class: "btn btn-primary btn-sm ms-2 text-capitalize-first",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.enable2fa()), ["prevent"]))
                      }, _toDisplayString(_ctx.helper.trans("labels.enable")), 1))
                    : _createCommentVNode("", true),
                  (_ctx.user?.is2faEnabled)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        type: "button",
                        class: "btn btn-danger ms-2 btn-sm text-capitalize-first",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.disable2fa()), ["prevent"]))
                      }, _toDisplayString(_ctx.helper.trans("labels.disable")), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }, 512)
        ])
      ]),
      _createVNode(_component_b_modal, {
        title: _ctx.helper.trans('labels.2fa'),
        modelValue: _ctx.twoFactorQrCodeModalData !== null,
        "footer-class": "d-flex justify-content-end",
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ($event === false && (_ctx.twoFactorQrCodeModalData = null)))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, _toDisplayString(_ctx.helper.trans('labels.2fa_step_1')), 1),
          _createElementVNode("div", _hoisted_20, [
            (_ctx.twoFactorQrCodeModalData)
              ? (_openBlock(), _createBlock(_component_vue_qrcode, {
                  key: 0,
                  value: _ctx.twoFactorQrCodeModalData.qr,
                  tag: "svg",
                  class: "w-100",
                  options: { width: '100%' }
                }, null, 8, ["value"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("input", {
                type: "text",
                class: "form-control form-control-sm font-monospace",
                value: _ctx.twoFactorQrCodeModalData?.secret,
                readonly: ""
              }, null, 8, _hoisted_23),
              _createVNode(_component_copy_button, {
                class: "btn btn-copy",
                value: _ctx.twoFactorQrCodeModalData?.secret
              }, null, 8, ["value"])
            ])
          ]),
          _createElementVNode("div", null, _toDisplayString(_ctx.helper.trans('labels.2fa_step_2')), 1),
          (_ctx.twoFactorQrCodeModalData)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: _ctx.helper.getErrors('2fa', `code`),
                    class: "w-100"
                  }, {
                    default: _withCtx((parentProps) => [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "data-maska": "999 999",
                        "data-maska-tokens": "9:[0-9]",
                        class: _normalizeClass([parentProps.class, "form-control form-control-lg"]),
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.twoFactorQrCodeModalData.code) = $event)),
                        placeholder: _ctx.helper.trans('labels.2fa_enter_code')
                      }, null, 10, _hoisted_26), [
                        [_directive_maska],
                        [_vModelText, _ctx.twoFactorQrCodeModalData.code]
                      ])
                    ]),
                    _: 1
                  }, 8, ["errors"])
                ]),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.enable2faConfirm()), ["prevent"])),
                  class: "btn btn-sm btn-primary text-capitalize-first mt-2"
                }, _toDisplayString(_ctx.helper.trans('labels.2fa_verify')), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        footer: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.twoFactorQrCodeModalData = null)),
            class: "btn btn-outline-dark btn-sm text-capitalize-first"
          }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1)
        ]),
        _: 1
      }, 8, ["title", "modelValue"])
    ]),
    (_ctx.isTrader || _ctx.isOperator || _ctx.isAdmin)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("h5", _hoisted_29, _toDisplayString(_ctx.helper.trans("labels.telegram")), 1)
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createVNode(_component_LoaderWrapper, { ref: "telegramLoader" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.helper.trans("labels.telegram_bot_notifications")) + ":", 1),
                    _createElementVNode("div", _hoisted_34, [
                      (_ctx.telegramMe === null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_35))
                        : (_ctx.telegramMe?.id === null)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_36, [
                              _cache[16] || (_cache[16] = _createElementVNode("i", { class: "fa fa-warning" }, null, -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.helper.trans("labels.telegram_bot_not_linked")), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_37, "@" + _toDisplayString(_ctx.telegramMe?.username), 1)),
                      (_ctx.telegramMe && _ctx.telegramMe?.id === null)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 3,
                            type: "button",
                            class: "btn btn-sm btn-primary ms-2",
                            onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.createTgInviteRequest()), ["prevent"]))
                          }, [
                            _cache[17] || (_cache[17] = _createElementVNode("i", { class: "fa-brands fa-telegram" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.helper.trans("labels.telegram_link_account")), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.telegramMe && _ctx.telegramMe?.id)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 4,
                            type: "button",
                            onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.unlinkTgAccount()), ["prevent"])),
                            class: "btn btn-sm btn-danger ms-2"
                          }, [
                            _cache[18] || (_cache[18] = _createElementVNode("i", { class: "fa fa-times" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.helper.trans("labels.telegram_unlink_account")), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.telegramMe && _ctx.telegramMe?.id === null && _ctx.tgBotNotificationsUrl !== null)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 5,
                            href: _ctx.tgBotNotificationsUrl,
                            target: "_blank",
                            class: "d-flex"
                          }, _toDisplayString(_ctx.helper.trans('labels.tg_click_on_link')), 9, _hoisted_38))
                        : _createCommentVNode("", true),
                      _createElementVNode("a", _hoisted_39, null, 512)
                    ])
                  ]),
                  (_ctx.isTrader && _ctx.telegramMe?.id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.helper.trans("labels.telegram_bot_notifications_settings")) + ":", 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isTrader && _ctx.telegramMe?.id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(_ctx.TgNotification), (notification) => {
                          return (_openBlock(), _createElementBlock("div", _hoisted_43, [
                            _createElementVNode("div", _hoisted_44, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input",
                                value: notification,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.enabledNotifications) = $event)),
                                type: "checkbox",
                                id: notification,
                                disabled: notification === _ctx.TgNotification.NOTIFICATION_WEEKLY_REPORT && !_ctx.user?.tgChatGroupId
                              }, null, 8, _hoisted_45), [
                                [_vModelCheckbox, _ctx.enabledNotifications]
                              ]),
                              _createElementVNode("label", {
                                class: "form-check-label",
                                for: notification
                              }, _toDisplayString(_ctx.helper.trans(`tg_notifications.${notification}`)), 9, _hoisted_46)
                            ]),
                            (notification === _ctx.TgNotification.NOTIFICATION_WEEKLY_REPORT && !_ctx.user?.tgChatGroupId)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(_ctx.helper.trans('labels.weekly_report_tg_group_hint')), 1))
                              : _createCommentVNode("", true)
                          ]))
                        }), 256)),
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("button", {
                            type: "button",
                            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.saveNotifications && _ctx.saveNotifications(...args))),
                            class: "btn btn-outline-success btn-sm text-capitalize-first"
                          }, _toDisplayString(_ctx.helper.trans('button.save')), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 512)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_49, [
      _createElementVNode("div", _hoisted_50, [
        _createElementVNode("h5", _hoisted_51, _toDisplayString(_ctx.helper.trans("labels.profile")), 1)
      ]),
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", _hoisted_53, [
          _createVNode(_component_LoaderWrapper, { ref: "passwordLoader" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("label", _hoisted_56, _toDisplayString(_ctx.helper.trans("labels.timezone")) + ":", 1),
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("form", _hoisted_58, [
                      _createVNode(_component_Multiselect, {
                        class: "multiselect-sm",
                        name: "timezone",
                        id: "timezone",
                        options: _ctx.moment.tz.names(),
                        modelValue: _ctx.timezone,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.timezone) = $event)),
                        "select-label": "Select",
                        "open-direction": "bottom",
                        autocomplete: "timezone",
                        multiple: false,
                        searchable: true,
                        "internal-search": true,
                        "clear-on-select": false,
                        "close-on-select": true,
                        "options-limit": 100,
                        limit: 1000,
                        "show-no-results": false,
                        "hide-selected": false
                      }, null, 8, ["options", "modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("label", _hoisted_60, _toDisplayString(_ctx.helper.trans("labels.lang")) + ":", 1),
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("form", _hoisted_62, [
                      _createVNode(_component_Multiselect, {
                        class: "multiselect-sm",
                        name: "lang",
                        id: "lang",
                        options: ['ru', 'en'],
                        modelValue: _ctx.lang,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.lang) = $event)),
                        "select-label": "Select",
                        "open-direction": "bottom",
                        autocomplete: "lang",
                        multiple: false,
                        searchable: true,
                        "internal-search": true,
                        "clear-on-select": false,
                        "close-on-select": true,
                        "options-limit": 100,
                        limit: 1000,
                        "show-no-results": false,
                        "hide-selected": false
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.helper.trans("labels.new_password")) + ":", 1),
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("form", _hoisted_66, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.password) = $event)),
                        type: "password",
                        autocomplete: "off",
                        name: "pwd-new",
                        class: "form-control form-control-sm",
                        id: "inputPassword"
                      }, null, 512), [
                        [_vModelText, _ctx.password]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("label", _hoisted_68, _toDisplayString(_ctx.helper.trans("labels.confirm_password")) + ":", 1),
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("form", _hoisted_70, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.passwordConfirm) = $event)),
                        type: "password",
                        autocomplete: "off",
                        name: "pwd-new-repeat",
                        class: "form-control form-control-sm",
                        id: "inputPasswordConf"
                      }, null, 512), [
                        [_vModelText, _ctx.passwordConfirm]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.updateProfile()), ["prevent"])),
                      class: "btn btn-sm btn-primary text-capitalize-first"
                    }, _toDisplayString(_ctx.helper.trans("labels.save_changes")), 1)
                  ])
                ])
              ])
            ]),
            _: 1
          }, 512)
        ])
      ])
    ])
  ]))
}